/**
 * Hard-coded a_modules ids for the pages of THIS admin panel that gate on
 * a module row (see url-permission-mapping.service.ts and app.routes.ts).
 *
 * Must stay in sync with webApi/src/utils/adminModuleCatalog.ts, which is
 * the source of truth and seeds these rows on boot. Modules in this list are
 * reserved: the UI shows no delete action and no active toggle for them.
 */
export const ADMIN_MODULE_IDS = {
    /** "User Roles" — the page that grants admin permissions to admin roles. */
    USER_ROLES: 22,
    /** "Admin Module Groups" — manages a_modulegroups. */
    ADMIN_MODULE_GROUPS: 68,
    /** "Admin Modules" — manages a_modules + a_modulepermissions. */
    ADMIN_MODULES: 69,
} as const;
